import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import FormTextField from "../../../components/textField/formTextField";
import LaddaButton from "../../../components/buttons/laddaButton";
import ToastNotification from "../../../components/toastNotification";

import {
  callApiAsync,
  getCallAccessoryData,
  postAddAccessoryData
} from "../../../services/apiService";
import SimpleSelect from "../../../components/selects/simpleSelect";
import { icons } from "../../../constants";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import AddAccessory from "../modals/addAccessory";
import ModalComponent from "../../../components/modals";

const validationSchema = yup.object({
  accessory: yup
    .number()
    .typeError("El accesorio es obligatorio")
    .required("El accesorio es obligatorio"),
  amountAccessory: yup
    .number()
    .required("La cantidad es obligatoria")
    .integer("La cantidad debe ser un número entero")
    .min(0, "La cantidad no puede ser menor a 0")
    .typeError("Este campo debe ser un número")
});

const SelectAccessoryModal = ({
  brandIdSelected,
  open,
  close,
  getAccessoryData,
  selectedRow,
  setSelectedRow,
  biomedicalId,
  accessoryTable,
  isViewer,
  onZeroQuantitySaved
}) => {
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [accessoryOptions, setAccessoryOptions] = useState([]);

  const [openAddAccessoryModal, setOpenAddAccessoryModal] = useState(false);

  const hadleCloseAddAccessory = () => {
    setOpenAddAccessoryModal(false);
  };

  const {
    control,
    formState: { errors },
    getValues,
    reset,
    setValue
  } = useForm({
    resolver: yupResolver(validationSchema),
    mode: "all"
  });

  useEffect(() => {
    getAccessoryDataM();
  }, [brandIdSelected]);

  const getAccessoryDataM = () => {
    if (brandIdSelected == null) return;
    callApiAsync(
      () => getCallAccessoryData(brandIdSelected, biomedicalId),
      (data) => {
        setAccessoryOptions(data.list);
      }
    );
  };

  useEffect(() => {
    getAccessoryData();
  }, []);

  useEffect(() => {
    if (!open) return;
    if (selectedRow) {
      loadData(selectedRow);
    } else {
      cleanData();
    }
  }, [open, selectedRow]);

  const handleAddAccessoryWithValidation = () => {
    const accessoryId = Number(getValues("accessory"));

    if (!Number.isFinite(accessoryId) || accessoryId <= 0) {
      setToastMessage("Debe seleccionar un accesorio.");
      setShowToast(true);
      return;
    }

    if (selectedRow === null) {
      const existingAccessory = accessoryTable.find(
        (item) => Number(item.accessoryId) === accessoryId
      );

      if (existingAccessory) {
        setToastMessage(
          "El accesorio ya se encuentra en la lista de accesorios añadidos."
        );
        setShowToast(true);
        return;
      }
    } else {
      const accessoryIdConflict = accessoryTable.some(
        (item) =>
          Number(item.accessoryId) === accessoryId &&
          Number(item.id) !== Number(selectedRow.id)
      );

      if (accessoryIdConflict) {
        setToastMessage(
          "Ya existe otro accesorio con el mismo ID en la lista."
        );
        setShowToast(true);
        return;
      }
    }
    const accessoryData = {
      id: selectedRow == null ? 0 : selectedRow.id,
      accessoryId,
      brandSpecificId: selectedRow?.brandSpecificId ?? null,
      partNumber: getValues("partNumberAccessory"),
      quantity: Number(getValues("amountAccessory")),
      biomadicalEquipmentId: biomedicalId
    };
    callApiAsync(
      () => postAddAccessoryData(accessoryData),
      () => {
        setToastMessage("Accesorio gregado exitosamente.");
        setShowToast(true);
        cleanData();
        getAccessoryData();
        if (accessoryData.quantity === 0) {
          onZeroQuantitySaved?.();
        }
        handleClose();
      }
    );
  };

  const loadData = (data) => {
    setValue("accessory", data.accessoryId ?? data.id ?? "");
    setValue("partNumberAccessory", data.partNumberAccessory || "");
    setValue(
      "amountAccessory",
      data.quantity != null && data.quantity !== "" ? data.quantity : ""
    );
  };

  const cleanData = () => {
    setValue("accessory", "");
    setValue("partNumberAccessory", "");
    setValue("amountAccessory", "");
  };

  const handleClose = () => {
    cleanData();
    setSelectedRow(null);
    reset();
    close();
  };
  return (
    <div>
      <ModalComponent
        open={open}
        handleClose={() => {
          handleClose();
        }}
        title={selectedRow ? "Editar accesorio" : "Agregar accesorio"}
        actions={<div className="HContainer j-center w-complete"></div>}
      >
        <div>
          <ToastNotification
            severity="warn"
            summary={toastMessage}
            detail=""
            showToast={showToast}
            setShowToast={setShowToast}
          />

          <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={8} md={4.5}>
              <p className="create-label ml-0">Accesorio:</p>
              <SimpleSelect
                name="accessory"
                control={control}
                options={accessoryOptions}
                error={errors.accessory}
                hideLabel={true}
                margin={"0"}
                disabled={isViewer}
              />
            </Grid>
            <Grid item xs={4} md={1.5} className="VContainer align-end">
              {isViewer ? (
                <></>
              ) : (
                <div>
                  <LaddaButton
                    type="button"
                    width={"40px"}
                    fontSize={"12px"}
                    height={"40px"}
                    variant="contained"
                    margin={"0"}
                    onClick={() => {
                      if (brandIdSelected != null) {
                        setOpenAddAccessoryModal(true);
                      }
                    }}
                  >
                    <img className="btn-icon" src={icons.plusIcon} alt="icon" />
                  </LaddaButton>
                </div>
              )}
            </Grid>
            <Grid item xs={12} md={6}>
              <p className="create-label ml-0">Número de Parte:</p>
              <FormTextField
                name="partNumberAccessory"
                control={control}
                label=""
                error={errors.partNumberAccessory}
                margin={"0"}
                disabled={isViewer}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <p className="create-label ml-0">Cantidad:</p>
              <FormTextField
                name="amountAccessory"
                control={control}
                label=""
                error={errors.amountAccessory}
                margin={"0"}
                disabled={isViewer}
              />
            </Grid>
            <Grid item md={6}></Grid>
          </Grid>
          {isViewer ? (
            <></>
          ) : (
            <div className="j-center">
              {selectedRow == null && (
                <LaddaButton
                  type="button"
                  variant="contained"
                  disabled={selectedRow != null}
                  onClick={() => {
                    handleAddAccessoryWithValidation();
                  }}
                >
                  <p className="button_text">Agregar Accesorio</p>
                </LaddaButton>
              )}
              {selectedRow != null && (
                <LaddaButton
                  type="button"
                  variant="contained"
                  disabled={selectedRow == null}
                  onClick={() => {
                    handleAddAccessoryWithValidation();
                  }}
                >
                  <p className="button_text">Guardar</p>
                </LaddaButton>
              )}
            </div>
          )}

          <AddAccessory
            open={openAddAccessoryModal}
            close={hadleCloseAddAccessory}
            setAccessoryOptions={setAccessoryOptions}
            brandIdSelected={brandIdSelected}
            accessoryOptions={accessoryOptions}
          />
        </div>
      </ModalComponent>
    </div>
  );
};

export default SelectAccessoryModal;
